import React from 'react';
import { useIsAdmin, useIsManager, useIsUser } from 'hooks';
import User from './user';
import Management from './management';

const Status = ({ ...rest }) => {
  const isUser = useIsUser();
  const isManager = useIsManager();
  const isAdmin = useIsAdmin();

  return (
    <>
      {isUser ? <User {...rest} /> : null}
      {isManager || isAdmin ? <Management {...rest} /> : null}
    </>
  );
};

export default Status;
